import script from "./manage_prosthesis.vue?vue&type=script&setup=true&lang=js"
export * from "./manage_prosthesis.vue?vue&type=script&setup=true&lang=js"

import "./manage_prosthesis.vue?vue&type=style&index=0&id=2e3e3122&lang=css"

const __exports__ = script;

export default __exports__